import cn from 'bem-cn';

import { Stack } from '../../UI';

import { ChallengePrizes } from './ChallengePrizes';
import { ChallengeRequirements } from './ChallengeRequirements';
import { ChallengeCriterias } from './ChallengeCriterias';
import { ChallengeChecklist } from './ChallengeChecklist';
import { ChallengeInfoBodyProps } from './ChallengeInfoBody.types';
import './ChallengeInfoBody.scss';

const b = cn('challenge-info-body');

export const ChallengeInfoBody = (props: ChallengeInfoBodyProps) => {
    const { title, requirements, checklist } = props.challenge;

    return (
        <Stack className={b()}>
            <ChallengePrizes challengeTitle={title} />
            <ChallengeRequirements requirements={requirements} />
            <ChallengeCriterias challengeTitle={title} />
            <ChallengeChecklist checklist={checklist} />
        </Stack>
    );
};
